<template>
  <div class="layout">
    <main>
      <TopBar />
      <!-- <Header /> -->
      <slot></slot>
      <!-- <Footer /> -->
    </main>
    <Navbar />
  </div>
</template>
